<template>
  <tutorial-layout
    title="Vue Router"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">Overview text goes here.</p>
  </tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
export default {
  name: "VModel",
  mixins: [uiView],
  created() {},
  data() {
    return {
      text1: "Example Text",
    };
  },
  components: { tutorialLayout },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
        {
          title: "Official Router",
          href: "https://vuejs.org/v2/guide/routing.html",
        },
        {
          title: "The Vue Router",
          href: "https://flaviocopes.com/vue-router/",
        },
        {
          title: "Routing",
          href: "https://router.vuejs.org/",
        },
      ];
    },
    youtubeLinks() {
      return [
        {
          title: "Routing for beginners",
          href: "https://www.youtube.com/embed/juocv4AtrHo",
        },
        {
          title: "Routing with Vue Router",
          href: "https://www.youtube.com/embed/X-cs3UfqfYA",
        },
        {
          title: "Routing Setup",
          href: "https://www.youtube.com/embed/4lk9-PYensI",
        },
      ];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
</style>
